<template>
  <div class="morph">
    <div class="promo_wrap" v-if="!dicStore.promo.is_loading">
      <div class="b2b_news ">
        <div class="column" v-for="item in dicStore.promo.data" :key="item.id">
          <div class="item grey_border">
            <div class="thumb" @click="show_modal(item)">
              <img v-if="item.properties.image.value" v-bind="{ src: '/storage/'+item.properties.image.value }">
              <img v-else v-bind="{ src: '/storage/photos/b2b_news/no_image.png'}">
            </div>
            <div class="txt">
              <div class="name" @click="show_modal(item)">{{item.properties.title.value}}</div>
              <div class="date" v-if="item.properties.str_date.value"><span>ДО {{item.properties.str_date.value}}</span></div>
              <div class="decr" v-html="item.properties.descr.value"></div>
              <div class="more" v-if="item.properties.content.value" @click="show_modal(item)">Подробнее...</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="o_loading"><loading></loading></div>
  </div>
</template>

<script>

import {useDicStore} from "@/stores/DicStore";
import {useUserStore} from "@/stores/UserStore";
import loading from "@/components/support/loading";

export default {
  name: "Promo",
  components: {
    loading,
  },
  setup() {
    const dicStore = useDicStore()
    const userStore = useUserStore()
    return {
      dicStore,
      userStore
    }
  },
  data: function (){
    return {
      page: {
        title: 'Акции',
        show_menu: false,
      }
    }
  },
  methods: {
    fill_promo(){
      this.dicStore.fill_promo();
    },
    show_modal(item){
      this.dicStore.promo.modal = item;
      this.$emit('openModalPromo');
    },
  },
  created() {
    this.$emit('setPagesVars', this.page);
    if(Object.keys(this.dicStore.promo.data).length === 0)
    {
      this.fill_promo();
    }
  },
}
</script>

<style scoped>
.b2b_news .grey_border {
  padding: 0px;
}
.b2b_news {
  margin: 36px 0 57px 0px;
}
.b2b_news .item {
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: 30px;
}
.b2b_news .item .thumb {
  width: 415px;
  height: auto;
  flex-shrink: 0;
  cursor: pointer;
}
.b2b_news .item .thumb img {
  width: 100%;
  max-width: 375px;
  height: auto;
  margin: 20px;
}
.b2b_news .item .txt {
  margin: 20px;
  margin-left: 0px;
  color: #1A3751;
}
.b2b_news .item .name {
  font-size: 24px;
  font-weight: bold;
  margin: 0 0 10px 0;
  cursor: pointer;
}
.b2b_news .item .name:hover {
  text-decoration: underline;
}
.b2b_news .item .decr {
  font-size: 18px;
  line-height: 24px;
}
.b2b_news .item .decr p{
  margin: 0 0 20px 0;
}
.b2b_news .item .date {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #FFF;
text-transform: uppercase;
}
.b2b_news .item .date span {
  background: rgba(0, 158, 213, 1);
  padding: 5px 10px 5px 10px;
  font-size: 18px;
  font-weight: 600;
  line-height: 36px;
}
.b2b_news .item .more {
  cursor: pointer;
  color: #009ED5;
  font-size: 18px;
  margin: 10px 0 20px 0;
  text-decoration: underline;
}
.b2b_news .item .more:hover {
  text-decoration: none;
}
@media only screen and (max-width: 1200px) {
  .b2b_news .item {
    flex-direction: column;
  }
  .b2b_news .item .txt {
    margin: 20px 0 0 0px;
  }
  .b2b_info .item,.b2b_news .item {
    width: 90%;
  }
  .b2b_info .grey_border,.b2b_news .grey_border {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>
